import React from "react";
import BasketballProgramCard from "./BasketballProgramCard";

function BasketballProgramGrid({ programs }) {
  return (
    <div className="container basketball-program-grid">
      <div className="row g-4">
        {programs.map((program) => (
          <div
            className="col-12 col-md-6 col-xl-4 d-flex justify-content-center"
            key={program.id}
          >
            <BasketballProgramCard program={program} />
          </div>
        ))}
      </div>
    </div>
  );
}

export default BasketballProgramGrid;